export const stripHtml = (html) => {
  if (!html) return '';
  const str = String(html);
  const formattedHtml = str
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<div>/gi, '');
  const tmp = document.createElement('DIV');
  tmp.innerHTML = formattedHtml;
  return tmp.textContent || tmp.innerText || '';
};

const StripHtml = ({ html }) => {
  return <>{stripHtml(html)}</>;
};

export default StripHtml;
